import { isEstimate } from "@gigsync/protocol";
import { log } from "../log.js";
/**
 * The estimate for a request, or undefined: none for this job, the server unreachable, or any other failure. An
 * estimate is off the core path (ADR 0030 §6): whoever asked falls back to the city's rates, then the owner's numbers.
 */
export async function lookupEstimate(api, request) {
    try {
        const answer = await api.estimate(request);
        if (isEstimate(answer))
            return answer;
        log.info("no estimate", { trade: request.trade, reason: answer.none });
        return undefined;
    }
    catch (err) {
        log.warn("estimate lookup failed", { trade: request.trade, error: err instanceof Error ? err.name : String(err) });
        return undefined;
    }
}
//# sourceMappingURL=lookup.js.map